/**
 * The office's time zone for the tasks store (fixed 2026-10-06).
 *
 * The store used to read `rootState.settings.allSettings.GENERAL_TIMEZONE` — but there is NO
 * `settings` store module, so that was ALWAYS undefined and every office fell back to New York:
 * a task completed after 21:00 Pacific was stamped with TOMORROW's date, one completed before
 * 06:00 in South Africa with YESTERDAY's, and AFRICA/MASERU never got its DD/MM date format in
 * tasks/getTaskDetails. The settings live in `state.customer.settings`, an array of
 * `{ Property, PropertyValue }` rows (store/customer.js loads `select Property, PropertyValue from
 * teamio.settings`) — the same place store/conversationsV2.js reads GENERAL_TIMEZONE from.
 *
 * Kept IMPORT-FREE (node-tests execute it verbatim): the zone check is passed in.
 */

export const DEFAULT_OFFICE_TIME_ZONE = 'America/New_York';

/**
 * @param {Array<{Property: string, PropertyValue: string}>|null} settings  state.customer.settings
 * @param {Function} [isZone]  (name) => boolean — e.g. name => !!moment.tz.zone(name)
 * @returns {string} the site's GENERAL_TIMEZONE, or New York when it is missing or not a real zone
 */
export function officeTimezoneOf(settings, isZone) {
  const list = Array.isArray(settings) ? settings : [];
  const row = list.find(s => s && s.Property === 'GENERAL_TIMEZONE');
  const zone = row && typeof row.PropertyValue === 'string' ? row.PropertyValue.trim() : '';
  if (!zone) return DEFAULT_OFFICE_TIME_ZONE;
  if (typeof isZone === 'function' && !isZone(zone)) return DEFAULT_OFFICE_TIME_ZONE;
  return zone;
}
